import { squaresApi } from '../../../api';
import type { Square, LabelSquareInput } from '../../../types';
import type { SquareStateGetter } from '../types';

export const createLabelSquare = (get: SquareStateGetter) => {
  return async (boardId: string, input: LabelSquareInput): Promise<Square> => {
    const square = await squaresApi.label(boardId, input);
    await get().fetchSquares(boardId);
    return square;
  };
};
